var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":_vm.color}},[_c('use',{attrs:{"xlink:href":require('@it-enterprise/web-app-common/src/assets/rmd-icons.svg') + `#ICON_${_vm.image.toUpperCase()}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }